export interface AiSessionSummaryInterface {
    NEEDS_SUMMARY: 'NEEDS_SUMMARY',
    HAS_SUMMARY: 'HAS_SUMMARY'
}

export interface SessionSummaryNeedsAdded {
    sessionSummaryNeedsAdded?: AiSessionSummaryInterface;
}

export enum AiSessionSummaryEnum {
    NEEDS_SUMMARY = 'NEEDS_SUMMARY',
    HAS_SUMMARY = 'HAS_SUMMARY'
}

